import { TaskListItem } from 'shared';
import { TaskGroupItem } from 'dm-src/types/task-group-item';

export class TaskGroup {
    public deliveryDate: Date;
    public tasks: TaskGroupItem[] = new Array<TaskGroupItem>();
}
